import { ALL_UPGRADE_IDS, UPGRADES } from '../../data/upgrades';
import type { RunUpgradeDef } from '../../types';

/** Returns 3 unique upgrades, biased away from ones already picked this run. */
export function generateShopOffers(
  ownedIds: readonly string[],
  count = 3,
): RunUpgradeDef[] {
  const available = ALL_UPGRADE_IDS.filter((id) => !ownedIds.includes(id));
  // Shuffle then take.
  const shuffled = [...available].sort(() => Math.random() - 0.5);
  const picked = shuffled.slice(0, Math.min(count, shuffled.length));
  return picked.map((id) => UPGRADES[id]!);
}
